import { getProfile } from "./http";

function assigned(profile = getProfile()) {
  return new Set(profile && Array.isArray(profile.permissions) ? profile.permissions : []);
}

function requested(values) {
  return values.length > 0 && values.every((value) => typeof value === "string" && value.length > 0);
}

function isAdmin(profile = getProfile()) {
  const permissions = assigned(profile);
  return permissions.has("SYSTEM_ADMIN") || permissions.has("IS_ADMIN");
}

export function hasPermissions(...values) {
  if (!requested(values)) return false;
  if (isAdmin()) return true;
  const permissions = assigned();
  return values.some((permission) => permissions.has(permission));
}

export function hasPermission(...values) {
  return hasPermissions(...values);
}

export function hasPermissionAll(...values) {
  if (!requested(values)) return false;
  if (isAdmin()) return true;
  const permissions = assigned();
  return values.every((permission) => permissions.has(permission));
}

export function hasPermissionsStrict(...values) {
  if (!requested(values)) return false;
  const permissions = assigned();
  return values.some((permission) => permissions.has(permission));
}

export function hasPermissionAllStrict(...values) {
  if (!requested(values)) return false;
  const permissions = assigned();
  return values.every((permission) => permissions.has(permission));
}